import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import { MappingCell, YesNoCell, CellFunction, DirectCell } from '../../cells';
import { IEpxDischarge } from '../../../../../libs/apps/epxdischarge';
import { TriStateLiteral } from '../../../../../libs/session';

const IssueMapping = {
  MEDICATION: 'receiving/taking medications',
  DRESSING: 'changing dressing',
  APPOINTMENT: 'appointment',
  FALL: 'recent falls/stumbles/fear of falls',
  APPOINTMENT_SCHEDULE: 'no follow-up appointment',
  ADDITIONAL_HELP: 'requests additional help',
  OTHER: 'other questions'
};

const IssuesCell: CellFunction<IEpxDischarge> = ({
  row: { original: session }
}) => {
  let label = 'N/A';
  const parts = [];
  if (session.issues) {
    for (const key of Object.keys(session.issues)) {
      if (session.issues[key]) {
        parts.push(IssueMapping[key]);
      }
    }
  }
  if (parts.length) {
    label = parts.join(', ');
  }
  return <span>{label}</span>;
};

const getColumns = (sessions: IEpxDischarge[]): Column<IEpxDischarge>[] => {
  const hasProgramComment = sessions.some(
    (session) =>
      typeof session.programComment === 'string' &&
      session.programComment.trim().length > 0
  );
  const columns: Column<IEpxDischarge>[] = [
    {
      Header: 'Feeling',
      id: 'feeling',
      Cell: ResponseGuard(
        MappingCell('feeling', TriStateLiteral) as CellFunction<IEpxDischarge>
      )
    },
    {
      Header: 'Requested Contact',
      id: 'wantsToSpeak',
      Cell: ResponseGuard(
        YesNoCell('wantsToSpeak') as CellFunction<IEpxDischarge>
      )
    },
    {
      Header: 'Issues',
      id: 'issues',
      Cell: ResponseGuard(IssuesCell)
    }
  ];
  if (hasProgramComment) {
    columns.push({
      Header: 'Program Comment',
      accessor: 'programComment',
      Cell: ResponseGuard(
        DirectCell('programComment') as CellFunction<IEpxDischarge>
      )
    });
  }
  return columns;
};

const EpxDischargeTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  return (
    <SessionTable<IEpxDischarge>
      url="/epxdischarge/data/"
      getColumns={getColumns}
      {...props}
    />
  );
};

export default EpxDischargeTable;
